import { NgModule } from '@angular/core';
import { StudentPaymentsComponent } from './student-payments.component';
import { SharedModule } from '@shared/shared.module';
import { MatDialogCustomModule } from '../mat-dialog-custom/mat-dialog-custom.module';
import { MatDialogModule } from '@angular/material/dialog';
import { SelectCountryModule } from '@shared/select-country/select-country.module';
import { InputLanguageModule } from '@shared/input-language/input-language.module';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { UploadDocumentsModule } from '@shared/upload-documents/upload-documents.module';
import { MatAccordionModule } from '@shared/mat-accordion/mat-accordion.module';
import { UploadFilesModule } from '@shared/upload-files/upload-files.module';
import { CurrencyCountryPipeModule } from '@pipes/currency-country/currency-country.module';
import { MatCardModule } from '@angular/material/card';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgxMaskDirective } from 'ngx-mask';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [StudentPaymentsComponent],
  imports: [
    SharedModule,
    MatDialogCustomModule,
    MatDialogModule,
    MatDatepickerModule,
    SelectCountryModule,
    InputLanguageModule,
    UploadDocumentsModule,
    MatAccordionModule,
    UploadFilesModule,
    CurrencyCountryPipeModule,
    MatCardModule,
    MatProgressSpinnerModule,
    CurrencyCountryPipeModule,
    MatCardModule,
    MatTooltipModule,
    NgxMaskDirective,
    MatIconModule,
    MatMenuModule,
    MatButtonModule,
  ],
  exports: [StudentPaymentsComponent],
})
export class StudentPaymentsModule {}
